import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Range } from '@highmobility/console-ui-components';

type AzureDataBatchingThresholdProps = {
  title: string;
  subtitle: string;
  name: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  initialValue: number;
  range: { min: number; max: number };
  getThumbText: (value: number) => string;
  step: number;
};

export const AzureDataBatchingThreshold: FC<AzureDataBatchingThresholdProps> = observer((props) => {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center gap-3">
        <h5 className="text-body-regular font-bold">{props.title}</h5>
        <p className="text-body-small text-white-60">{props.subtitle}</p>
      </div>
      <Range
        initialValue={props.initialValue}
        name={props.name}
        onChange={props.onChange}
        range={props.range}
        getThumbText={props.getThumbText}
        step={props.step}
      />
    </div>
  );
});
